export default __webpack_public_path__ + "static/media/cert-startup-hkgcsmeaa.4d37af84.jpg";